import { useQuery } from "@tanstack/react-query";
import Axios from "@/lib/axios-instance";

// Type for the feature plan response
type Feature = {
    id: number;
    feature_id: number;
    value: string;
    feature_name: string;
    feature_type: string;
};

type FeaturePlanResponse = {
    data: {
        plan_id: string;
        plan_name: string;
        is_active: boolean;
        plan_created_at: string;
        plan_price: string;
        plan_description: string;
        plans_interval: string;
        features: Feature[];
    };
    meta?: any;
};

// API call to get all plan features
export const getFeaturePlan = async (plan_id: string) => {
    const response = await Axios.get<FeaturePlanResponse>(`/plan_feature/by-plan/${plan_id}`);
    return response.data;
};

// React Query hook
export const useGetFeaturePlan = (plan_id: string) => {
    return useQuery({
        queryKey: ["get-feature-plan", plan_id],
        queryFn: () => getFeaturePlan(plan_id),
        staleTime: 5 * 60 * 1000, // Optional: keeps data fresh for 5 minutes
        retry: 1, // Optional: retry once on failure
        enabled: !!plan_id, // Only run if ID is provided
    });
};
